export default function EditIcon() {
  return (
    <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M5.99999 10H10.5H5.99999Z" fill="#A27E8A" />
      <path
        d="M1.5 9.16273C1.5 8.91814 1.5 8.79585 1.52763 8.68076C1.55213 8.57872 1.59253 8.48118 1.64736 8.39171C1.7092 8.29079 1.79568 8.20431 1.96863 8.03136L8.25001 1.74999C8.66423 1.33578 9.3358 1.33578 9.75001 1.74999C10.1642 2.1642 10.1642 2.83578 9.75001 3.24999L3.46864 9.53136C3.29569 9.70431 3.20921 9.79079 3.1083 9.85263C3.01883 9.90746 2.92128 9.94786 2.81925 9.97236C2.70416 9.99999 2.58186 9.99999 2.33727 9.99999H1.5V9.16273Z"
        fill="#A27E8A"
      />
      <path
        d="M5.99999 10H10.5M1.5 9.99999H2.33727C2.58186 9.99999 2.70416 9.99999 2.81925 9.97236C2.92128 9.94786 3.01883 9.90746 3.1083 9.85263C3.20921 9.79079 3.29569 9.70431 3.46864 9.53136L9.75001 3.24999C10.1642 2.83578 10.1642 2.1642 9.75001 1.74999C9.3358 1.33578 8.66423 1.33578 8.25001 1.74999L1.96863 8.03136C1.79568 8.20431 1.7092 8.29079 1.64736 8.39171C1.59253 8.48118 1.55213 8.57872 1.52763 8.68076C1.5 8.79585 1.5 8.91814 1.5 9.16273V9.99999Z"
        stroke="#A27E8A"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
}
